import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';
import { ProcessStage } from './process-stage';

export class Process implements ViewModel {
  friendlyTypeNameSingular: string = 'Process';
  apiRoute: string = CONFIG.apiRoutes.eventProcesses;

  id: string;
  name: string;
  description: string;
  processStages: ProcessStage[] = [];

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;
    this.name = data.name;
    this.description = data.description;

    if (data.processStages) {
      data.processStages.forEach((processStage: any) => {
        const newProcessStage = new ProcessStage();
        newProcessStage.loadFromJson(processStage);
        this.processStages.push(newProcessStage);
      });
    }
  }

  get startStage(): ProcessStage {
    return this.processStages.find(e => e.startStage === true);
  }

  get endStage(): ProcessStage {
    return this.processStages.find(e => e.endStage === true);
  }
}
